import { Group } from '@mantine/core';
import { BriefForm } from '../components/Brief/BriefForm';
import { OutputPane } from '../components/Brief/OutputPane';
import { RunsSidebar } from '../components/Brief/RunsSidebar';
import { SectionHeading } from '../components/Brief/SectionHeading';
import { UseSameButton } from '../components/Brief/UseSameButton';
import styles from './Brief.module.css';

export default function BriefPage() {
  return (
    <div className={styles.layout} data-testid="brief-page">
      <div className={styles.briefCol} data-testid="brief-form-section">
        <Group justify="space-between" align="center" mb={8} wrap="nowrap">
          <SectionHeading mb={0}>Brief</SectionHeading>
          <UseSameButton />
        </Group>
        <BriefForm />
      </div>

      <div className={styles.outputCol}>
        <OutputPane />
      </div>

      <div className={styles.runsCol}>
        <RunsSidebar />
      </div>
    </div>
  );
}
